"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagsProvider = FlagsProvider;
const react_1 = __importDefault(require("react"));
const use_flags_hook_1 = require("../hooks/use-flags.hook");
const context_1 = require("../context");
function FlagsProvider(props) {
    const value = (0, use_flags_hook_1.useFlags)(props);
    return (react_1.default.createElement(context_1.FlagsContext.Provider, { value: value }, props.children));
}
//# sourceMappingURL=flags-provider.component.js.map